import { useEffect, useRef } from 'react'

export function useCSSEffect(cssGenerator, deps = []) {
  let styleRef = useRef(null)

  useEffect(() => {
    let css = cssGenerator()
    if (!styleRef.current) {
      styleRef.current = document.createElement('style')
      document.head.appendChild(styleRef.current)
    }
    styleRef.current.textContent = css

    return () => {
      if (styleRef.current) {
        styleRef.current.remove()
        styleRef.current = null
      }
    }
  }, [cssGenerator, ...deps])
}
